export class SendMessage{
    Attachments:any;
    Classes:any;
    IsEntireSchool:boolean=false;
    IsParticularClass:boolean=true;
    IsParticularParent:boolean=true;
    IsParticularSection:boolean =true;
    Message:any;
    Parents:any;
    SchoolId:string;
    SchoolUserId:string;
    Subject:string;
    Token:string;
    SMS:string;
    IsPriority:boolean=false;
    SchoolName:string;
    OneSignal:string;
    Reach:string;
    IsEmail: boolean;
}
export class CreateClassModel{
    grade: any = [];
    section: any = [];
    subject: string = '';
}
export class ApprovalClassModel{
    schoolId: string;
    teacherId: string;
    standardId: string;
    sectionId: string;
    createdBy: string;
}
export class ApprovalClassDetailModel{
    SchoolId: string;
    StandardId: string;
    SectionId: string;
}
export class GCLClassDetailModel{
    gcourseid: string;
    gcoursename: string;
    gownerid: string;
    teacherfolderid: string;
    schoolId: string
    standardId: string;
    sectionId: string;
    createdBy: string;
}


// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/components/googleClassroom/googleClassroom.model.ts